<template>
    <div class="components-container" id="mobileViewPort">
        <div id="mobileMode">
            <div id="titleArea">
                <div class="titleText">调课系统</div>
                <div class="titleButton">
                    <el-button class="custom-el-button" type="primary" @click="showHomePage">
                        <i class="el-icon-s-home"></i> 首页
                    </el-button>
                </div>
            </div>
            <div id="queryArea">
                <div class="filter-container">
                    <div class="formItem">
                        <el-select v-model="queryForm.xnxqbm" filterable placeholder="学年学期" style="width:210px;" clearable>
                            <el-option v-for="item in xnxqInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                            </el-option>
                        </el-select>
                        <el-select v-model="queryForm.auditState" filterable placeholder="审核状态" style="width:120px;" clearable>
                            <el-option v-for="item in auditInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="formItem text-center">
                        <el-button @click="handleFilter" type="gray"><i class="el-icon-search"></i> 查询</el-button>
                        <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i> 重置</el-button>
                        <el-button @click="queryDialogVisible = true" type="primary"><i class="el-icon-more"></i> 更多</el-button>
                        <el-button @click="addRec" type="success"><i class="el-icon-circle-plus-outline"></i> 申请</el-button>
                    </div>
                </div>
            </div>

            <!-- 搜索内容弹框 -->
            <el-dialog id="queryDialog" class="formDialog" title="查询信息" width="90%" :visible.sync="queryDialogVisible">
                <el-row>
                    <el-select v-model="queryForm.xnxqbm" filterable placeholder="学年学期" style="width:100%" clearable>
                        <el-option v-for="item in xnxqInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-row>
                <el-row>
                    <el-input v-model="queryForm.courseName" @keyup.enter.native="handleFilter" style="width: 100%" placeholder="课程名称" clearable>
                    </el-input>
                </el-row>
                <el-row>
                    <el-input v-model="queryForm.className" @keyup.enter.native="handleFilter" style="width: 100%" placeholder="班级名称" clearable>
                    </el-input>
                </el-row>
                <el-row>
                    <el-input v-model="queryForm.teacherName" @keyup.enter.native="handleFilter" style="width: 100%" placeholder="申请教师" clearable>
                    </el-input>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.applyType" filterable placeholder="申请类型" style="width:100%" clearable>
                        <el-option v-for="item in applyInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.auditState" filterable placeholder="审核状态" style="width:100%" clearable>
                        <el-option v-for="item in auditInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-row>
                <div slot="footer" class="dialog-footer text-center">
                    <el-button type="gray" @click="handleFilter">查 询</el-button>
                    <el-button style="margin-left: 10px;" type="gray" @click="handleReset">重 置</el-button>
                    <el-button style="margin-left: 10px;" @click="queryDialogVisible = false">取 消</el-button>
                </div>
            </el-dialog>

            <div id="loadingMask" class="maskStyle">
                <div class="maskFont">调课信息保存中，请稍候...</div>
            </div>
            <div id="listArea" @scroll="handleScroll">
                <div v-if="tableData==null || tableData.length==0" class="cardTips">没有调课信息</div>
                <div class="cardMain" v-for="(item,index) in tableData" :key="index">
                    <div class="cardText">
                        <p><label for="">申请教师：</label>{{ item.creatorName }}</p>
                        <p><label for="">学年学期：</label>{{ item.xnxqmc }}</p>
                        <p><label for="">课程名称：</label>{{ item.courseName }}</p>
                        <p><label for="">班级名称：</label>{{ item.className }}</p>
                        <p><label for="">申请类型：</label>{{ item.applyTypeName }}</p>
                        <div class="auditStateImg">
                            <img :src="loadStateImg(item)" alt="">
                        </div>
                    </div>
                    <div class="cardInput" >
                        <el-button v-if="item.auditState == '-1' && item.xnxqbm == curterm" size="small" @click="modRec(item);" type="warning">
                            <i class="el-icon-edit"></i>&nbsp;编辑
                        </el-button>
                        <el-button v-if="item.auditState !='-1' && item.auditAuth=='0' || item.xnxqbm != curterm" size="small" @click="showDetailInfo(item);" type="info">
                            <i class="el-icon-tickets"></i>&nbsp;详情
                        </el-button>
                        <el-button v-if="item.auditAuth == '1' && item.xnxqbm == curterm" size="small" @click="auditRec(item);" type="primary">
                            <i class="el-icon-edit-outline"></i>&nbsp;审核
                        </el-button>
                        <el-button v-if="item.auditState != '-1'" size="small" @click="showAuditList(item);">
                            <i class="el-icon-document-copy"></i>&nbsp;审核信息
                        </el-button>
                    </div>
                </div>
                <div v-if="total>2 && total>tableData.length" id="loadingTips">
                    <i class="el-icon-loading"></i>&nbsp;信息加载中，请稍候...
                </div>
            </div>

            <el-dialog id="mainDialog" class="formDialog" :title="dialogTitle" :visible.sync="dialogVisible" @closed="closeDialog" width="90%">
                <el-scrollbar id="mainDialogScroll" ref="mainDialogScroll">
                    <el-form ref="curdForm" :model="curdForm" label-width="84px" label-position="left" width="100%">
                        <!-- 新建，编辑 -->
                        <div v-if="editType=='new' || editType=='edit'">
                            <el-form-item label="申请类型" prop="applyType">
                                <el-select v-model="curdForm.applyType" filterable placeholder="请选择申请类型" style="width:90%;" @change="applyTypeChange">
                                    <el-option v-for="item in applyInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="申请教师" prop="applyTeacher">
                                <span v-if="userAuth.indexOf('@1@')==-1 || (editType!='new' && editType!='edit') " style="line-height:40px;">{{ curdForm.applyTeacherName }}</span>
                                <el-select v-if="userAuth.indexOf('@1@')>-1 && (editType=='new' || editType=='edit')" v-model="curdForm.applyTeacher" filterable placeholder="请选择申请教师" style="width:90%;" @change="applyTeacherChange">
                                    <el-option v-for="item in teacherInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="专业名称" prop="majorCode">
                                <el-select v-model="curdForm.majorCode" filterable :placeholder="majorholder" style="width:90%;" @change="applyMajorChange" :disabled="disabled_major">
                                    <el-option v-for="item in majorInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="班级名称" prop="classCode">
                                <el-select v-model="curdForm.classCode" filterable :placeholder="classholder" style="width:90%;" @change="applyClassChange" :disabled="disabled_class">
                                    <el-option v-for="item in classInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="课程名称" prop="courseCode">
                                <el-select v-model="curdForm.courseCode" filterable :placeholder="courseholder" style="width:90%;" @change="applyCourseChange" :disabled="disabled_course">
                                    <el-option v-for="item in courseInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="调课原因" prop="adjustReason">
                                <el-select v-model="curdForm.adjustReason" filterable placeholder="请选择调课原因" style="width:45%;" @change="adjustReasonChange">
                                    <el-option v-for="item in adjustReasonInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                    </el-option>
                                </el-select>
                                <el-button v-show="uploadButton" size="mini" style="margin-left:5px;" @click="showUpload" type="success"><i class="el-icon-upload2"></i>&nbsp;附件上传</el-button>
                            </el-form-item>

                            <el-form-item label="变更理由" prop="changeReason">
                                <el-input v-model="curdForm.changeReason" placeholder="请填写变更理由" autoComplete="on" type="textarea" style="width:90%"
                                    :rows="3" show-word-limit maxlength="500"></el-input>
                            </el-form-item>

                            <!-- 调课 -->
                            <div v-if="adjustFlag=='1'">
                                <el-form-item label="原计划周数">
                                    <el-select v-model="curdForm.yjhskzc" filterable placeholder="请选择周数" style="width:90%;" @change="yjhskzcChange" multiple>
                                        <el-option v-for="item in yjhskzcInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="原计划星期">
                                    <el-select v-model="curdForm.yjhxq" filterable placeholder="请选择星期" style="width:90%;" @change="yjhxqChange">
                                        <el-option v-for="item in yjhxqInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="原计划节数">
                                    <el-select v-model="curdForm.yjhsjxl" filterable placeholder="请选择节数" style="width:90%;" @change="yjhsjxlChange" multiple>
                                        <el-option v-for="item in yjhsjxlInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="调整后周数">
                                    <el-select v-model="curdForm.tzhskzc" filterable placeholder="请选择周数" style="width:90%;" @change="tzhskzcChange" multiple>
                                        <el-option v-for="item in tzhskzcInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="调整后星期">
                                    <el-select v-model="curdForm.tzhxq" filterable placeholder="请选择星期" style="width:90%;" @change="tzhxqChange">
                                        <el-option v-for="item in tzhxqInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="调整后节数">
                                    <el-select v-model="curdForm.tzhsjxl" filterable placeholder="请选择节数" style="width:90%;" @change="tzhsjxlChange" multiple>
                                        <el-option v-for="item in tzhsjxlInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>


                                <el-form-item label="授课教师">
                                    <span style="line-height:40px;">{{ curdForm.yjhskjsxm }}</span>
                                </el-form-item>

                                <el-form-item label="授课地点">
                                    <span v-if="sameFlag!='true'" style="line-height:40px;">{{ curdForm.yjhcdmc }}</span>
                                    <div v-for="(site,i) in yjhsiteList" style="">
                                        <span v-if="sameFlag=='true'" style="line-height:40px;">{{ yjhsiteList[i].name }}  ===》</span>
                                        <el-select v-if="sameFlag=='true'" v-model="tzhsiteList[i].value" filterable placeholder="请选择授课地点" style="width:90%;" @change="siteChange(tzhsiteList[i].value,i)">
                                            <el-option v-for="item in tzhsiteInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </el-form-item>

                                <!-- <el-form-item label="其它说明" prop="otherExplain">
                                    <el-input v-model="curdForm.otherExplain" placeholder="请填写其它说明" autoComplete="on" type="textarea"
                                        :rows="5" show-word-limit maxlength="500"></el-input>
                                </el-form-item> -->
                            </div>

                            <!-- 代课 -->
                            <div v-if="adjustFlag=='4'">
                                <el-form-item label="代课周数">
                                    <el-select v-model="curdForm.yjhskzc" filterable placeholder="请选择周数" style="width:90%;" @change="yjhskzcChange" multiple>
                                        <el-option v-for="item in yjhskzcInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="代课星期">
                                    <el-select v-model="curdForm.yjhxq" filterable placeholder="请选择星期" style="width:90%;" @change="yjhxqChange">
                                        <el-option v-for="item in yjhxqInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="代课节数">
                                    <el-select v-model="curdForm.yjhsjxl" filterable placeholder="请选择节数" style="width:90%;" @change="yjhsjxlChange" multiple>
                                        <el-option v-for="item in yjhsjxlInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="授课教师">
                                    <span v-if="sameFlag!='true'" style="line-height:40px;">{{ curdForm.yjhskjsbh }}</span>
                                    <div v-for="(tea,i) in yjhteaList" style="">
                                        <span v-if="sameFlag=='true'" style="line-height:40px;">{{ yjhteaList[i].name }}  ===》</span>
                                        <el-select v-if="sameFlag=='true'" v-model="tzhteaList[i].value" filterable placeholder="请选择授课地点" style="width:90%;" @change="teaChange(tzhteaList[i].value,i)">
                                            <el-option v-for="item in tzhteacherInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </el-form-item>

                                <el-form-item label="授课地点">
                                    <span v-if="sameFlag!='true'" style="line-height:40px;">{{ curdForm.yjhcdmc }}</span>
                                    <div v-for="(site,i) in yjhsiteList" style="">
                                        <span v-if="sameFlag=='true'" style="line-height:40px;">{{ yjhsiteList[i].name }}  ===》</span>
                                        <el-select v-if="sameFlag=='true'" v-model="tzhsiteList[i].value" filterable placeholder="请选择授课地点" style="width:90%;" @change="siteChange(tzhsiteList[i].value,i)">
                                            <el-option v-for="item in tzhsiteInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </el-form-item>

                                <!-- <el-form-item label="其它说明" prop="otherExplain">
                                    <el-input v-model="curdForm.otherExplain" placeholder="请填写其它说明" autoComplete="on" type="textarea"
                                        :rows="5" show-word-limit maxlength="500"></el-input>
                                </el-form-item> -->
                            </div>

                            <!-- 补课 -->
                            <div v-if="adjustFlag=='3'">
                                <el-form-item label="补课周数">
                                    <el-select v-model="curdForm.tzhskzc" filterable placeholder="请选择周数" style="width:90%;" @change="tzhskzcChange" multiple>
                                        <el-option v-for="item in tzhskzcInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="补课星期">
                                    <el-select v-model="curdForm.tzhxq" filterable placeholder="请选择星期" style="width:90%;" @change="tzhxqChange">
                                        <el-option v-for="item in tzhxqInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="补课节数">
                                    <el-select v-model="curdForm.tzhsjxl" filterable placeholder="请选择节数" style="width:90%;" @change="tzhsjxlChange" multiple>
                                        <el-option v-for="item in tzhsjxlInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="授课教师" >
                                    <el-select v-model="curdForm.tzhskjsbh" filterable placeholder="请选择授课教师" style="width:90%;" multiple>
                                        <el-option v-for="item in tzhteacherInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="授课地点">
                                    <el-select v-model="curdForm.tzhcdbh" filterable placeholder="请选择授课地点" style="width:90%;" multiple>
                                        <el-option v-for="item in tzhsiteInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <!-- <el-form-item label="其它说明" prop="otherExplain">
                                    <el-input v-model="curdForm.otherExplain" placeholder="请填写其它说明" autoComplete="on" type="textarea"
                                        :rows="5" show-word-limit maxlength="500"></el-input>
                                </el-form-item> -->
                            </div>

                            <!-- 停课 -->
                            <div v-if="adjustFlag=='2'">
                                <el-form-item label="停课周数">
                                    <el-select v-model="curdForm.yjhskzc" filterable placeholder="请选择周数" style="width:90%;" @change="yjhskzcChange" multiple>
                                        <el-option v-for="item in yjhskzcInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="停课星期">
                                    <el-select v-model="curdForm.yjhxq" filterable placeholder="请选择星期" style="width:90%;" @change="yjhxqChange">
                                        <el-option v-for="item in yjhxqInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="停课节数">
                                    <el-select v-model="curdForm.yjhsjxl" filterable placeholder="请选择节数" style="width:90%;" @change="yjhsjxlChange" multiple>
                                        <el-option v-for="item in yjhsjxlInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="授课教师">
                                    <span style="line-height:40px;">{{ curdForm.yjhskjsxm }}</span>
                                </el-form-item>

                                <el-form-item label="授课地点">
                                    <span style="line-height:40px;">{{ curdForm.yjhcdmc }}</span>
                                </el-form-item>

                                <!-- <el-form-item label="其它说明" prop="otherExplain">
                                    <el-input v-model="curdForm.otherExplain" placeholder="请填写其它说明" autoComplete="on" type="textarea"
                                        :rows="5" show-word-limit maxlength="500"></el-input>
                                </el-form-item> -->
                            </div>
                        </div>

                        <!-- 审核，详情 -->
                        <div v-if="editType=='audit' || editType=='show'">
                            <el-form-item label="申请类型" prop="applyType">
                                {{ curdForm.applyTypeName }}
                            </el-form-item>

                            <el-form-item label="申请教师" prop="applyTeacher">
                                {{ curdForm.applyTeacherName }}
                            </el-form-item>

                            <el-form-item label="专业名称" prop="majorCode">
                                {{ curdForm.majorName }}
                            </el-form-item>

                            <el-form-item label="班级名称" prop="classCode">
                                {{ curdForm.className }}
                            </el-form-item>

                            <el-form-item label="课程名称" prop="courseCode">
                                {{ curdForm.courseName }}
                            </el-form-item>

                            <el-form-item label="调课原因" prop="adjustReason">
                                {{ curdForm.adjustReasonName }}
                                <el-button v-show="uploadButton" size="medium" style="margin-left:50px;" @click="showUpload" type="success"><i class="el-icon-upload2"></i>&nbsp;附件上传</el-button>
                            </el-form-item>

                            <el-form-item label="变更理由" prop="changeReason">
                                {{ curdForm.changeReason }}
                            </el-form-item>

                            <!-- 调课 -->
                            <div v-if="adjustFlag=='1'">
                                <el-form-item label="原计划周数">
                                    {{ curdForm.yjhskzc+'' }}
                                </el-form-item>

                                <el-form-item label="原计划星期">
                                    {{ parseInt(curdForm.yjhxq,10) }}
                                </el-form-item>

                                <el-form-item label="原计划节数">
                                    {{ formatJS(curdForm.yjhsjxl+'') }}
                                </el-form-item>

                                <el-form-item label="调整后周数">
                                    {{ curdForm.tzhskzc+'' }}
                                </el-form-item>

                                <el-form-item label="调整后星期">
                                    {{ parseInt(curdForm.tzhxq,10) }}
                                </el-form-item>

                                <el-form-item label="调整后节数">
                                    {{ formatJS(curdForm.tzhsjxl+'') }}
                                </el-form-item>

                                <el-form-item label="授课教师">
                                    {{ curdForm.yjhskjsxm+'' }}
                                </el-form-item>

                                <el-form-item label="授课地点">
                                    <div v-for="(site,i) in yjhsiteList">
                                        {{ yjhsiteList[i].name+'' }} ===》 {{ tzhsiteList[i].name+'' }}
                                    </div>
                                </el-form-item>

                                <!-- <el-form-item label="其它说明" prop="otherExplain">
                                    {{ curdForm.otherExplain }}
                                </el-form-item> -->
                            </div>

                            <!-- 代课 -->
                            <div v-if="adjustFlag=='4'">
                                <el-form-item label="代课周数">
                                    {{ curdForm.yjhskzc+'' }}
                                </el-form-item>

                                <el-form-item label="代课星期">
                                    {{ parseInt(curdForm.yjhxq,10) }}
                                </el-form-item>

                                <el-form-item label="代课节数">
                                    {{ formatJS(curdForm.yjhsjxl+'') }}
                                </el-form-item>

                                <el-form-item label="授课教师">
                                    <div v-for="(site,i) in yjhteaList">
                                        {{ yjhteaList[i].name+'' }} ===》 {{ tzhteaList[i].name+'' }}
                                    </div>
                                </el-form-item>

                                <el-form-item label="授课地点">
                                    <div v-for="(site,i) in yjhsiteList">
                                        {{ yjhsiteList[i].name+'' }} ===》 {{ tzhsiteList[i].name+'' }}
                                    </div>
                                </el-form-item>

                                <!-- <el-form-item label="其它说明" prop="otherExplain">
                                    {{ curdForm.otherExplain }}
                                </el-form-item> -->
                            </div>

                            <!-- 补课 -->
                            <div v-if="adjustFlag=='3'">
                                <el-form-item label="补课周数">
                                    {{ curdForm.tzhskzc+'' }}
                                </el-form-item>

                                <el-form-item label="补课星期">
                                    {{ parseInt(curdForm.tzhxq,10) }}
                                </el-form-item>

                                <el-form-item label="补课节数">
                                    {{ formatJS(curdForm.tzhsjxl+'') }}
                                </el-form-item>

                                <el-form-item label="授课教师">
                                    {{ curdForm.tzhskjsxm+'' }}
                                </el-form-item>

                                <el-form-item label="授课地点">
                                    {{ curdForm.tzhcdmc+'' }}
                                </el-form-item>

                                <!-- <el-form-item label="其它说明" prop="otherExplain">
                                    {{ curdForm.otherExplain }}
                                </el-form-item> -->
                            </div>

                            <!-- 停课 -->
                            <div v-if="adjustFlag=='2'">
                                <el-form-item label="停课周数">
                                    {{ curdForm.yjhskzc+'' }}
                                </el-form-item>

                                <el-form-item label="停课星期">
                                    {{ parseInt(curdForm.yjhxq,10) }}
                                </el-form-item>

                                <el-form-item label="停课节数">
                                    {{ formatJS(curdForm.yjhsjxl+'') }}
                                </el-form-item>

                                <el-form-item label="授课教师">
                                    {{ curdForm.yjhskjsxm+'' }}
                                </el-form-item>

                                <el-form-item label="授课地点">
                                    {{ curdForm.yjhcdmc+'' }}
                                </el-form-item>

                                <!-- <el-form-item label="其它说明" prop="otherExplain">
                                    {{ curdForm.otherExplain }}
                                </el-form-item> -->
                            </div>
                        </div>
                    </el-form>
                </el-scrollbar>

                <div v-if="operateButtonVisible" slot="footer" class="dialog-footer text-center">
                    <el-button v-if="auditDisabled == false && editType!='show'" type="primary" :loading="formSubmiting" @click="saveInfo()">保 存</el-button>
                    <el-button v-if="auditDisabled == false && editType!='show'" type="warning" :loading="formSubmiting" @click="submitRec()">提 交</el-button>
                    <el-button v-if="auditDisabled == true && editType!='show' && applyused==false" :disabled="applyused" type="warning" :loading="formSubmiting" @click="auditOption();">审核意见</el-button>
                    <el-button v-if="editType!='show'" @click="dialogVisible = false">取 消</el-button>
                </div>
            </el-dialog>

            <el-dialog title="附件上传" :visible.sync="attachmentVisible" width="90%" style="top:50px;" @close="closeAttachDialog" append-to-body>
                <div style="height:360px;">
                    <el-table :data="fileTableData" v-loading.body="fileTableLoading" element-loading-text="数据加载中"
                        style="width: 300px;margin-top:15px;" :height="fileTableHeight" ref="multipleTable" stripe border fit>
                        <el-table-column v-if="operateAreaVisible" type="selection" width="30"></el-table-column>
                        <el-table-column label="文件名" prop="fileName" align="center" min-width="100px"></el-table-column>
                        <el-table-column label="类型" prop="fileType" align="center" width="50px"></el-table-column>
                        <el-table-column align="center" width="90px">
                            <template slot="header" slot-scope="scope">
                                <div v-show="operateAreaVisible">
                                    <div>
                                        <el-button size="mini" @click="clickUpload" type="success"><i class="el-icon-upload2"></i>&nbsp;上传</el-button>
                                    </div>
                                    <div style="margin-top:5px;">
                                        <el-button size="mini" @click="confirmDelFile" type="danger"><i class="el-icon-delete"></i>&nbsp;删除</el-button>
                                    </div>
                                </div>
                                <div v-if="viewAreaVisible">操作</div>
                            </template>
                            <template slot-scope="scope">
                                <div>
                                    <el-button size="mini" @click="showAttachment(scope.row);" type="primary">
                                        <i class="el-icon-view"></i>&nbsp;预览
                                    </el-button>
                                </div>
                                <div style="margin-top:5px;">
                                    <el-button size="mini" @click="downloadAttachment(scope.row);" type="primary">
                                        <i class="el-icon-download"></i>&nbsp;下载
                                    </el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-dialog>

            <el-dialog title="附件上传" :visible.sync="uploadDialogVisible" width="360px" style="top:50px;" @close="closeUploadDialog" append-to-body>
                <div class="attachmentUpload" style="width: 100%;">
                    <el-upload class="upload-demo" ref="uploadFile" drag action="#" :file-list="fileList" :http-request="getFile"
                        :multiple="multipleType" :auto-upload="false" :limit="10" :on-change="onChangeFile" :on-success="handleFilUploadSuccess"
                        :on-remove="handleRemove" :on-exceed="handleExceed">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                            <div style="font-size:16px; font-weight:bold;">将文件拖到此处，或<em>点击上传</em></div>
                            <div style="margin-top:30px; font-size:16px; font-weight:bold;">
                                <el-tooltip placement="top">
                                    <div slot="content">
                                        允许上传的文件类型如下（单个文件大小{{ fileSizeLimit }}MB以内）<br/>
                                        文本文件：txt、doc、docx、xls、xlsx、pdf、ppt、pptx<br/>
                                        图片文件：jpg、jpeg、png、gif<br/>
                                        音/视频文件：mp3、mp4
                                    </div>
                                    <el-button plain>查看上传文件限制</el-button>
                                </el-tooltip>
                            </div>
                        </div>
                    </el-upload>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="handleUpload">确 定</el-button>
                    <el-button @click="closeUploadDialog">取 消</el-button>
                </span>
            </el-dialog>

            <!-- 审核dialog -->
            <el-dialog :title="detailDialogTitle" class="formDialog xsyjDialog" :visible.sync="detailDialogVisible" v-if="detailDialogVisible" width="90%">
                <div style="margin-top:10px;height:160px;">
                    <audit ref="audit" :key="timer" :itemCode="queryForm.itemCode" :relatedCode="selectRowData.id" :auditLevel="curdForm.auditLevel"
                        @auditCallback="auditCallback"></audit>
                </div>
            </el-dialog>

            <el-dialog class="formDialog" title="审核信息" :visible.sync="auditListDialogVisible" v-if="auditListDialogVisible" width="90%" top="150px">
                <div style="height:550px;">
                    <auditList ref="auditList" :relatedCode="selectRowData.id" :listHeight="350" :auditFlowInfo="auditFlowInfo"></auditList>
                </div>
            </el-dialog>

            <!-- 预览dialog -->
            <el-dialog :title="fileName" :visible.sync="previewerDialogVisible" v-if="previewerDialogVisible" width="90%" top="80px" append-to-body>
                <div style="height:100%;">
                    <previewer ref="previewer" :fileInfo="fileInfo" :height="600"></previewer>
                </div>
            </el-dialog>

        </div>
    </div>
</template>
<script>
    import { globalConfig } from 'static/config'
    import { confirmMsg, showNotify } from 'utils/message';
    import audit from 'views/mobile/audit.vue';
    import auditList from 'views/mobile/auditList.vue';
    import previewer from 'views/file/simplePreviewer.vue';

    export default {
        components: {
            audit,
            auditList,
            previewer,
        },
        data() {
            return {
                comboData: {
                    changeCode: null,
                    major: null,
                    class: null,
                },
                queryForm: {
                    pageNum: 1,
                    rowNum: 10,
                    xnxqbm: null,
                    courseName: null,
                    className: null,
                    teacherName: null,
                    applyType: null,
                    auditState: '',
                },
                timer: '', //时间戳,点击重新加载子页面
                tableData: [],
                currentPage: 1,
                limit: 10,
                total: null,
                tableLoading: true,
                selectRowData: null,
                selectRowDateTime: null,
                mainTableHeight: 500,
                fileTableHeight: 340,
                dialogTitle: "",
                dialogVisible: false,
                fieldVisible: false,
                schoolVisible: false,
                majorVisible: false,
                classVisible: false,
                attachmentVisible: false,
                operateAreaVisible: true,
                viewAreaVisible: false,

                uploadButton: false,
                fileTableLoading: false,
                fileTableData: [],
                uploadDialogVisible: false,
                multipleType: true, //上传 单个/多个文件//file: null, //上传选中的文件
                fileList: [], //上传选中的多个文件
                fileInfo: {
                    name: null,
                    type: null,
                    url: null,
                },
                previewerDialogVisible: false,
                fileName: null,
                fileSizeLimit: 100,

                yjhskzcInfo: [],//授课周次
                yjhxqInfo: [],//星期
                yjhsjxlInfo: [],//节次
                tzhskzcInfo: [],//授课周次
                tzhxqInfo: [],//星期
                tzhsjxlInfo: [],//节次
                adjustFlag: null,

                students: [],
                stuInfo: null,
                curdForm: {
                    id: '',
                    xnxqbm: '',
                    xnxqmc: '',
                    applyType: '',
                    applyTypeName: '',
                    applyTeacher: '',
                    applyTeacherName: '',
                    majorCode: '',
                    majorName: '',
                    classCode: '',
                    className: '',
                    courseCode: '',
                    courseName: '',
                    adjustReason: '',
                    adjustReasonName: '',
                    changeReason: '',
                    yjhskzc: '',
                    yjhxq: '',
                    yjhsjxl: '',
                    yjhskjsbh: '',
                    yjhskjsxm: '',
                    yjhcdbh: '',
                    yjhcdmc: '',
                    tzhskzc: '',
                    tzhxq: '',
                    tzhsjxl: '',
                    tzhskjsbh: '',
                    tzhskjsxm: '',
                    tzhcdbh: '',
                    tzhcdmc: '',
                    otherExplain: '',
                    submitState: '',
                    auditState: '',
                    auditLevel: '',
                    auditAuth: '',
                    totalAuditLevel: '',
                    stuConfirmState: '',
                    stuSuggestion: '',
                },
                curdRules: {
                    xnxqbm: [{required: true, message: "请选择学年学期", trigger: ["blur", "change"],}],
                    siteCode: [{required: true, message: "请选择申请场地", trigger: ["blur", "change"],}],
                    useDescription: [{required: true, message: "请填写使用说明", trigger: ["blur"],}],
                },
                formSubmiting: false,
                detailDialogTitle: '',
                detailDialogTop: '150px',
                detailDialogVisible: false,
                auditAreaVisible: false,
                auditListDialogVisible: false,
                auditParam: null,
                userCode: null,
                userName: null,
                userAuth: null,
                maskHeight: null,
                auditFlowInfo: null,

                xnxqInfo: [],//学年学期
                applyInfo: [], //场地信息
                auditInfo: [], //审核状态
                teacherInfo:[], //教师列表
                majorInfo: [], //专业
                classInfo: [], //班级
                courseInfo: [], //课程
                adjustReasonInfo: [], //调课原因
                tzhteacherInfo:[],
                tzhsiteInfo:[],
                saveing: false,//保存时禁用
                applyused: false,//课表信息有变更时禁用

                yjhteaList: [],
                yjhsiteList: [],
                tzhteaList: [],
                tzhsiteList: [],
                curterm: '',//当前学期
                disabled_major: true,
                disabled_class: true,
                disabled_course: true,
                majorholder: '',
                classholder: '',
                courseholder: '',
                sameFlag: 'true',
                errorFlag: '',

                auditDisabled: false,
                editType: null,
                editTimeType: null,
                editapplyDate: null,
                edituseTime: null,
                auditLevel: '',
                xgbh: null,
                numarray: [],
                totalAuditLevel: null,

                queryDialogVisible: false,
                operateButtonVisible: true,
            };
        },
        mounted() {
            this.applyInfo = [{"comboValue":"1","comboName":"调课"},{"comboValue":"2","comboName":"停课"},{"comboValue":"3","comboName":"补课"},{"comboValue":"4","comboName":"代课"}];
            this.numarray = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
            this.curdForm.applyType = "1";

            this.initOption();
        },
        methods: {
            showHomePage(){
                this.$router.push('/m/wx/home');
            },
            handleScroll(){
                if(this.checkVisible() && !this.tableLoading && this.total>this.tableData.length){
                    this.currentPage++;
                    this.queryList();
                }
            },
            checkVisible() {
                const ele = document.getElementById('loadingTips');
                if(ele){
                    let rect = ele.getBoundingClientRect();
                    //获取当前浏览器的视口高度，不包括工具栏和滚动条
                    //document.documentElement.clientHeight兼容 Internet Explorer 8、7、6、5
                    let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
                    //bottom top是相对于视口的左上角位置
                    //bottom大于0或者top-视口高度小于0可见
                    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
                }else{
                    return false;
                }
            },
            scrollToTop(){
                const ele = document.getElementById('listArea');
                if(ele){
                    ele.scrollTop = 0;
                }
            },
            loadStateImg(row){
                let str = "";
                if(row.auditState === '-1'){//未提交
                    return require('image/mobile/auditState/wtj.png');
                }else if(row.auditState === '0'){//待审核
                    return require('image/mobile/auditState/dsh.png');
                }else if(row.auditState === '3'){//审核中
                    return require('image/mobile/auditState/shz.png');
                }else if(row.auditState === '1'){//审核通过
                    return require('image/mobile/auditState/tg.png');
                }else if(row.auditState === '2'){//审核驳回
                    return require('image/mobile/auditState/bh.png');
                }else if(row.auditState === '4'){//班长确认
                    return require('image/mobile/auditState/dxsqr.png');
                }else if(row.auditState === '5'){//学生不同意
                    return require('image/mobile/auditState/bty.png');
                }
            },
            applyTypeFormatter(row){
                let str = '';
                if(applyType === '1'){
                    str = '调课';
                }else if(applyType === '2'){
                    str = '停课';
                }else if(applyType === '3'){
                    str = '补课';
                }else if(applyType === '4'){
                    str = '代课';
                }
                return str;
            },
            setMainDialogStyle(top, height){
                document.getElementById('mainDialog').style.top = top;
                this.$nextTick(() => {
                    document.getElementById('mainDialogScroll').style.height = height;
                });
            },
            restoreScroll(){
                this.$nextTick(() => {
                    this.$refs.mainDialogScroll.wrap.scrollTop = 0;
                });
            },
            closeDialog() {
                this.dialogVisible = false;

                if(this.$refs['curdForm'] !== undefined){
                    this.$refs['curdForm'].resetFields();
                }

            },
            //审状态列样式处理
            handleCellStyle({row, column, rowIndex, columnIndex}){
                let cellStyle;

                if(columnIndex === 7){
                    switch (row.auditState) {
                        case '-1':
                            cellStyle = 'color: #808080 !important;';
                            break;
                        case '0':
                            cellStyle = 'color: #e6a23c !important;';
                            break;
                        case '3':
                            cellStyle = 'color: #409eff !important;';
                            break;
                        case '1':
                            cellStyle = 'color: #00FF40 !important;';
                            break;
                        case '2':
                            cellStyle = 'color: #FE2E2E !important;';
                            break;
                        default:
                            cellStyle = '';
                    }

                    return cellStyle;
                }
            },
            initOption() {
                const paramMap = {
                    'name': 'combo_Info'
                }
                this.$api.courseAdjust.courseAdjust.initOption({
                    data: paramMap
                }).then(response => {
                    this.xnxqInfo = response.data.data.xnxq;
                    this.curterm = response.data.data.curterm;
                    //alert(this.curterm);

                    this.adjustReasonInfo = response.data.data.adjustReason;
                    this.queryForm.xnxqbm = response.data.data.curterm;
                    this.auditInfo = response.data.data.auditInfo;
                    this.userCode = response.data.data.userCode;
                    this.userName = response.data.data.userName;
                    this.userAuth = response.data.data.userAuth;

                    this.teacherOption();
                    this.siteOption();
                    //this.yjhskzcOption(this.curterm);
                    this.$nextTick().then(() => {
                        this.queryAuditParam();
                    });

                    if(this.curterm==""){
                        this.$alert("当前日期不属于允许调课的时间范围内！", "提示", {
                            confirmButtonText: "确定",
                    		customClass: 'el-message-box-mobile',
                        });
                        return;
                    }

                    this.disabled = true;
                    //alert(JSON.stringify(response.data.data));
                }).catch(error => {
                    console.log(error);
                });
            },
            queryList() {
                this.tableLoading = true;
                this.queryForm.pageNum = this.currentPage;
                this.queryForm.rowNum = this.limit;

                this.$api.courseAdjust.courseAdjust.queryList({
                    data: this.queryForm,
                }).then((response) => {
                    this.total = response.data.data.total;
                    //this.tableData = response.data.data.list;
                    this.tableData = this.tableData.concat(response.data.data.list);
                    this.tableLoading = false;

                    if(this.tableData.length>0){
                        for(let i=0;i<this.tableData.length;i++){
                            if(this.curdForm.id == this.tableData[i].id){
                                //this.auditLevel = this.tableData[i].auditLevel;
                                this.totalAuditLevel = this.tableData[i].totalAuditLevel;
                            }
                        }
                    }
                    $('#loadingMask').hide();
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            requeryList() {
                this.scrollToTop();
                this.tableData.length = 0;
                this.currentPage = 1;
                this.queryList();
            },
            teacherOption() {
                const paramMap = {
                    'name': 'combo_Info'
                }
                this.$api.courseAdjust.courseAdjust.teacherOption({
                    data: paramMap
                }).then(response => {
                    this.teacherInfo = response.data.data.teacher;
                    this.tzhteacherInfo = response.data.data.teacher;
                }).catch(error => {
                    console.log(error);
                });
            },
            siteOption() {
                const paramMap = {
                    'name': 'combo_Info'
                }
                this.$api.courseAdjust.courseAdjust.siteOption({
                    data: paramMap
                }).then(response => {
                    this.tzhsiteInfo = response.data.data.site;
                }).catch(error => {
                    console.log(error);
                });
            },
            majorOption() {
                const paramMap = {
                    'xnxqbm': this.curterm,
                    'applyType': this.curdForm.applyType,
                    'applyTeacher': this.curdForm.applyTeacher,
                    'auditState': this.curdForm.auditState,
                }
                this.$api.courseAdjust.courseAdjust.majorOption({
                    data: paramMap
                }).then(response => {
                    this.majorInfo = response.data.data.major;
                    if(this.majorInfo.length==0){
                        this.$message({
                            message: '申请教师没有排课信息，无法调课！',
                            type: 'warning'
                        });
                    }else{
                        this.disabled_major = false;
                        this.majorholder = '请选择专业';
                    }
                }).catch(error => {
                    console.log(error);
                });
            },
            classOption() {
                const paramMap = {
                    'xnxqbm': this.curterm,
                    'applyType': this.curdForm.applyType,
                    'applyTeacher': this.curdForm.applyTeacher,
                    'auditState': this.curdForm.auditState,
                    'majorCode': this.curdForm.majorCode,
                }
                this.$api.courseAdjust.courseAdjust.classOption({
                    data: paramMap
                }).then(response => {
                    this.classInfo = response.data.data.class;
                    this.disabled_class = false;
                    this.classholder = '请选择班级';
                }).catch(error => {
                    console.log(error);
                });
            },
            courseOption() {
                const paramMap = {
                    'xnxqbm': this.curterm,
                    'applyType': this.curdForm.applyType,
                    'applyTeacher': this.curdForm.applyTeacher,
                    'auditState': this.curdForm.auditState,
                    'classCode': this.curdForm.classCode,
                }
                this.$api.courseAdjust.courseAdjust.courseOption({
                    data: paramMap
                }).then(response => {
                    this.courseInfo = response.data.data.course;
                    this.disabled_course = false;
                    this.courseholder = '请选择课程';
                }).catch(error => {
                    console.log(error);
                });
            },
            yjhskzcOption(){
                const paramMap = {
                    'xnxqbm': this.curterm,
                    'id': this.curdForm.id,
                    'applyType': this.curdForm.applyType,
                    'skjhmxbh': this.curdForm.courseCode,
                    'auditState': this.curdForm.auditState,
                    'editType': this.editType,
                }
                this.$api.courseAdjust.courseAdjust.yjhskzcOption({
                    data: paramMap
                }).then(response => {
                    this.yjhskzcInfo = response.data.data.yjhskzc;
                    if(this.editType == "new"){
                        this.curdForm.yjhskzc = this.yjhskzcInfo[0].comboValue.split(",");
                    }
                    this.yjhxqOption();
                }).catch(error => {
                    console.log(error);
                });
            },
            yjhxqOption(yjhskzc){
                const paramMap = {
                    'xnxqbm': this.curterm,
                    'id': this.curdForm.id,
                    'applyType': this.curdForm.applyType,
                    'skjhmxbh': this.curdForm.courseCode,
                    'auditState': this.curdForm.auditState,
                    'editType': this.editType,
                    'yjhskzc': this.curdForm.yjhskzc+'',
                }
                this.$api.courseAdjust.courseAdjust.yjhxqOption({
                    data: paramMap
                }).then(response => {
                    this.yjhxqInfo = response.data.data.yjhxq;
                    if(this.yjhxqInfo.length>0){
                        this.curdForm.yjhxq = this.yjhxqInfo[0].comboValue;
                    }else{
                        this.curdForm.yjhxq = "";
                    }
                    this.yjhsjxlOption();
                }).catch(error => {
                    console.log(error);
                });
            },
            yjhsjxlOption(yjhskzc,yjhxq){
                const paramMap = {
                    'xnxqbm': this.curterm,
                    'id': this.curdForm.id,
                    'applyType': this.curdForm.applyType,
                    'skjhmxbh': this.curdForm.courseCode,
                    'auditState': this.curdForm.auditState,
                    'editType': this.editType,
                    'yjhskzc': this.curdForm.yjhskzc+'',
                    'yjhxq': this.curdForm.yjhxq,
                }
                this.$api.courseAdjust.courseAdjust.yjhsjxlOption({
                    data: paramMap
                }).then(response => {
                    this.yjhsjxlInfo = response.data.data.yjhsjxl;
                    if(this.yjhsjxlInfo.length>0){
                        this.curdForm.yjhsjxl = this.yjhsjxlInfo[0].comboValue.split(",");
                    }else{
                        this.curdForm.yjhsjxl = '';
                    }
                    this.teaAndSiteOption();
                }).catch(error => {
                    console.log(error);
                });
            },
            teaAndSiteOption(yjhskzc,yjhxq,yjhsjxl){
               const paramMap = {
                   'xnxqbm': this.curterm,
                   'id': this.curdForm.id,
                   'applyType': this.curdForm.applyType,
                   'skjhmxbh': this.curdForm.courseCode,
                   'auditState': this.curdForm.auditState,
                   'editType': this.editType,
                   'yjhskzc': this.curdForm.yjhskzc+'',
                   'yjhxq': this.curdForm.yjhxq,
                   'yjhsjxl': this.curdForm.yjhsjxl+'',
               }
                this.$api.courseAdjust.courseAdjust.teaAndSiteOption({
                    data: paramMap
                }).then(response => {
                    //this.teacherList = response.data.data.tealist;
                    //this.siteList = response.data.data.sitelist;

                    this.sameFlag = response.data.data.flag;
                    if(this.sameFlag == "true"){
                        if(this.editType=="new"){
                            this.curdForm.yjhskjsbh = response.data.data.teacherCode;
                            this.curdForm.yjhskjsxm = response.data.data.teacherName;
                            this.curdForm.yjhcdbh = response.data.data.siteCode;
                            this.curdForm.yjhcdmc = response.data.data.siteName;
                            if(this.curdForm.applyType != '3'){//不是补课
                                this.curdForm.tzhskjsbh = response.data.data.teacherCode;
                                this.curdForm.tzhcdbh = response.data.data.siteCode;
                            }

                            this.yjhteaList = [];
                            this.tzhteaList = [];
                            this.yjhsiteList = [];
                            this.tzhsiteList = [];
                            var teaid = this.curdForm.yjhskjsbh.split(",");
                            var teaxm = this.curdForm.yjhskjsxm.split(",");
                            for(let i=0;i<teaid.length;i++){
                                this.yjhteaList.push({'value':teaid[i],'name':teaxm[i]});
                                this.tzhteaList.push({'value':teaid[i],'name':teaxm[i]});
                            }

                            var siteid = this.curdForm.yjhcdbh.split(",");
                            var sitename = this.curdForm.yjhcdmc.split(",");
                            for(let i=0;i<siteid.length;i++){
                                this.yjhsiteList.push({'value':siteid[i],'name':sitename[i]});
                                this.tzhsiteList.push({'value':siteid[i],'name':sitename[i]});
                            }
                        }
                    }else{
                        this.curdForm.yjhskjsxm = "当前选择的课程时间的授课教师不同，无法统一设置。";
                        this.curdForm.yjhcdmc = "当前选择的课程时间的授课地点不同，无法统一设置。";
                    }
                }).catch(error => {
                    console.log(error);
                });
            },
            tzhskzcOption(){
                const paramMap = {
                    'xnxqbm': this.curterm,
                }
                this.$api.courseAdjust.courseAdjust.tzhskzcOption({
                    data: paramMap
                }).then(response => {
                    this.tzhskzcInfo = response.data.data.tzhskzc;
                    if(this.editType == "new"){
                        this.curdForm.tzhskzc = this.tzhskzcInfo[0].comboValue.split(",");
                    }
                    this.tzhxqOption();
                }).catch(error => {
                    console.log(error);
                });
            },
            tzhxqOption(){
                const paramMap = {
                    'xnxqbm': this.curterm,
                }
                this.$api.courseAdjust.courseAdjust.tzhxqOption({
                    data: paramMap
                }).then(response => {
                    this.tzhxqInfo = response.data.data.tzhxq;
                    if(this.editType == "new"){
                        this.curdForm.tzhxq = this.tzhxqInfo[0].comboValue;
                    }
                    this.tzhsjxlOption();
                }).catch(error => {
                    console.log(error);
                });
            },
            tzhsjxlOption(){
                const paramMap = {
                    'xnxqbm': this.curterm,
                }
                this.$api.courseAdjust.courseAdjust.tzhsjxlOption({
                    data: paramMap
                }).then(response => {
                    this.tzhsjxlInfo = response.data.data.tzhsjxl;
                    if(this.editType == "new"){
                        this.curdForm.tzhsjxl = this.tzhsjxlInfo[0].comboValue.split(",");
                    }
                }).catch(error => {
                    console.log(error);
                });
            },
            applyTypeChange(val){
                this.adjustFlag = val;
                this.curdForm.majorCode = '';
                this.curdForm.classCode = '';
                this.curdForm.courseCode = '';

                if(this.userAuth.indexOf('@1@')>-1){
                    this.curdForm.applyTeacher = "";
                    this.disabled_major = true;
                    this.majorholder = '请先选择申请教师';
                }

                this.disabled_class = true;
                this.disabled_course = true;
                this.classholder = '请先选择专业';
                this.courseholder = '请先选择班级';
                this.clearSkzcSjxl();
            },
            applyTeacherChange(){
                this.curdForm.majorCode = '';
                this.curdForm.classCode = '';
                this.curdForm.courseCode = '';

                if(this.userAuth.indexOf('@1@')>-1){
                    this.disabled_major = true;
                    this.majorholder = '请先选择申请教师';
                }

                this.disabled_class = true;
                this.disabled_course = true;
                this.classholder = '请先选择专业';
                this.courseholder = '请先选择班级';
                this.majorOption();
                this.clearSkzcSjxl();
            },
            applyMajorChange(){
                this.curdForm.classCode = '';
                this.curdForm.courseCode = '';
                this.disabled_class = true;
                this.disabled_course = true;
                this.classholder = '请先选择专业';
                this.courseholder = '请先选择班级';
                this.classOption();
                this.clearSkzcSjxl();
            },
            applyClassChange(val){
                this.curdForm.courseCode = '';
                this.disabled_course = true;
                this.courseholder = '请先选择班级';

                this.courseOption();
                this.siteOption();
                this.clearSkzcSjxl();

                //验证同班级是否存在未审核调课申请
                /* const paramMap = {
                    'xnxqbm': this.curdForm.xnxqbm,
                    'id': this.curdForm.id,
                    'classCode': val,
                }
                this.$api.courseAdjust.courseAdjust.checkUnauditAdjust({
                    data: paramMap
                }).then(response => {
                    let state = response.data.data.state;
                    if(state == "true"){
                        this.$message.warning('该班级存在未审核的调课申请，为防止课程冲突，请待审核后再申请！');
                    }else{
                        this.courseOption();
                        this.siteOption();
                        this.clearSkzcSjxl();
                    }
                }).catch(error => {
                    console.log(error);
                }); */
            },
            applyCourseChange(){
                this.adjustFlag = this.curdForm.applyType;
                this.clearSkzcSjxl();
                //读取当前课程的周次,星期,节次信息
                this.yjhskzcOption();
                this.tzhskzcOption();
            },
            adjustReasonChange(val){
                if(val == '01'){
                    this.uploadButton = true;
                }else{
                    this.uploadButton = false;
                }
            },
            yjhskzcChange(){
                this.yjhxqOption();
            },
            yjhxqChange(){
                this.yjhsjxlOption();
            },
            yjhsjxlChange(){
                this.teaAndSiteOption();
            },
            tzhskzcChange(){
                //this.tzhxqOption();
            },
            tzhxqChange(){
                //this.tzhsjxlOption();
            },
            tzhsjxlChange(){

            },
            teaChange(val,i){
                this.tzhteaList[i].value = val;

                let objtea = {};
                objtea = this.tzhteacherInfo.find((item)=>{
                    return item.comboValue === val;//筛选出匹配数据
                });
                this.tzhteaList[i].name = objtea.teacherName;
            },
            siteChange(val,i){
                this.tzhsiteList[i].value = val;

                let objsite = {};
                objsite = this.tzhsiteInfo.find((item)=>{
                    return item.comboValue === val;//筛选出匹配数据
                });
                this.tzhsiteList[i].name = objsite.siteName;
            },
            clearSkzcSjxl(){
                this.curdForm.yjhskzc = '';
                this.curdForm.yjhxq = '';
                this.curdForm.yjhsjxl = '';
                this.curdForm.yjhskjsbh = '';
                this.curdForm.yjhskjsxm = '';
                this.curdForm.yjhcdbh = '';
                this.curdForm.yjhcdmc = '';

                this.curdForm.tzhskzc = '';
                this.curdForm.tzhxq = '';
                this.curdForm.tzhsjxl = '';
                this.curdForm.tzhskjsbh = '';
                this.curdForm.tzhskjsxm = '';
                this.curdForm.tzhcdbh = '';
                this.curdForm.tzhcdmc = '';
            },
            handleFilter() {
                this.scrollToTop();
                this.tableData.length = 0;
                this.currentPage = 1;
                this.requeryList();
                this.queryDialogVisible = false;
            },
            handleReset() {
                this.limit = 10;
                this.currentPage = 1;
                this.queryForm.xnxqbm = null;
                this.queryForm.courseName = null;
                this.queryForm.className = null;
                this.queryForm.applyType = '';
                this.queryForm.auditState = '';
                this.tableLoading = false;
                this.requeryList();
            },
            handlePageChange(val) {
                this.currentPage = val;
                this.requeryList();
            },
            handleCurrentChange(val) {
               this.selectRowData = val;
            },
            handleSizeChange(val) {
                this.limit = val;
                this.currentPage = 1;
                this.requeryList();
            },
            querySearchStu(queryString, cb){
                let students = this.students;
                let results = queryString ? students.filter(this.createFilter(queryString)) : students;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (student) => {
                    return (student.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
                };
            },
            handleSelectStu(item){
                this.curdForm.stuCode = item.stuCode;
                this.curdForm.stuName = item.stuName;
                this.curdForm.oriMajorCode = item.majorCode;
                this.curdForm.oriMajorName = item.majorName;
                this.curdForm.oriClassCode = item.classCode;
                this.curdForm.oriClassName = item.className;
            },
            clearSelectStu(){
                document.activeElement.blur();
            },
            //选择学期
            selectChange(term){
                this.siteOption();
                this.timeslotOption(term);
            },
            rowClickDateTime(row){
                this.selectRowDateTime = row;
            },
            showUpload(){
                if(this.curdForm.id == ''){
                    this.$alert("请先保存申请后再上传附件", "提示", {
                        confirmButtonText: "确定",
                        customClass: 'el-message-box-mobile',
                    });
                    return;
                }else{
                    this.attachmentVisible = true;
                }
            },
            clickUpload(){
                if(this.curdForm.id == ''){
                    this.$alert("请先保存申请后再上传附件", "提示", {
                        confirmButtonText: "确定",
                        customClass: 'el-message-box-mobile',
                    });
                    return;
                }else{
                    this.uploadDialogVisible = true;
                }
            },
            addRec(){
                this.dialogTitle = "新建";
                this.disabled = false;
                this.auditDisabled = false;
                this.dialogVisible = true;
                this.editType = "new";
                this.curdForm.submitState = "0";
                this.curdForm.auditState = "-1";
                this.curdForm.adjustReason = "01";
                this.adjustReasonChange(this.curdForm.adjustReason);
                this.disabled_major = true;
                this.disabled_class = true;
                this.disabled_course = true;
                this.majorholder = '请先选择申请教师';
                this.classholder = '请先选择专业';
                this.courseholder = '请先选择班级';
                this.curdForm.xnxqbm = this.curterm;
                if(this.userAuth!='1'){
                    this.curdForm.applyTeacher = this.userCode;
                    this.curdForm.applyTeacherName = this.userName;
                    this.applyTeacherChange();
                }

                if(this.$refs['curdForm'] !== undefined){
                    this.$refs['curdForm'].resetFields();
                }
                this.restoreScroll();
            },
            modRec(rowData) {
                this.selectRowData = rowData;
                this.curdForm.id = rowData.id;

                if (this.selectRowData == null) {
                    this.$alert("请先选择一条记录", "提示", {
                        confirmButtonText: "确定",
                        customClass: 'el-message-box-mobile',
                    });
                    return;
                }

                if(this.editType == "audit"){
                    this.dialogTitle = "审核";
                    this.disabled = false;
                }else if(this.editType == "show"){
                    this.dialogTitle = "详情";
                    this.disabled = false;
                }else{
                    this.dialogTitle = "编辑";
                    this.disabled = false;
                    this.auditDisabled = false;
                    this.editType = "edit";
                }

                this.dialogVisible = true;
                this.$nextTick(() => {
                    this.adjustFlag = this.selectRowData.applyType;

                    this.curdForm.id = this.selectRowData.id;
                    this.curdForm.xnxqbm = this.selectRowData.xnxqbm;
                    this.curdForm.xnxqmc = this.selectRowData.xnxqmc;
                    this.curdForm.skjhmxbh = this.selectRowData.skjhmxbh;
                    this.curdForm.applyType = this.selectRowData.applyType;
                    this.curdForm.applyTypeName = this.selectRowData.applyTypeName;
                    this.curdForm.applyTeacher = this.selectRowData.applyTeacher;
                    this.curdForm.applyTeacherName = this.selectRowData.applyTeacherName;

                    this.curdForm.submitState = this.selectRowData.submitState;
                    this.curdForm.auditState = this.selectRowData.auditState;
                    this.majorOption();
                    this.curdForm.majorCode = this.selectRowData.majorCode;
                    this.curdForm.majorName = this.selectRowData.majorName;
                    this.classOption();
                    this.curdForm.classCode = this.selectRowData.classCode;
                    this.curdForm.className = this.selectRowData.className;
                    this.courseOption();
                    this.curdForm.courseCode = this.selectRowData.skjhmxbh;
                    this.curdForm.courseName = this.selectRowData.courseName;
                    this.curdForm.adjustReason = this.selectRowData.adjustReason;
                    this.curdForm.adjustReasonName = this.selectRowData.adjustReasonName;
                    this.adjustReasonChange(this.curdForm.adjustReason);
                    this.curdForm.changeReason = this.selectRowData.changeReason;
                    this.siteOption();

                    this.yjhskzcOption();
                    this.tzhskzcOption();

                    this.curdForm.yjhskzc = this.selectRowData.yjhskzc.split(",");
                    this.curdForm.yjhxq = this.selectRowData.yjhxq;
                    this.curdForm.yjhsjxl = this.selectRowData.yjhsjxl.split(",");

                    this.curdForm.tzhskzc = this.selectRowData.tzhskzc.split(",");
                    this.curdForm.tzhxq = this.selectRowData.tzhxq;
                    this.curdForm.tzhsjxl = this.selectRowData.tzhsjxl.split(",");

                    this.curdForm.yjhskjsbh = this.selectRowData.yjhskjsbh;
                    this.curdForm.yjhskjsxm = this.selectRowData.yjhskjsxm;
                    this.curdForm.yjhcdbh = this.selectRowData.yjhcdbh;
                    this.curdForm.yjhcdmc = this.selectRowData.yjhcdmc;

                    if(this.selectRowData.applyType!='3'){
                        this.curdForm.tzhskjsbh = this.selectRowData.tzhskjsbh;
                        this.curdForm.tzhcdbh = this.selectRowData.tzhcdbh;
                    }
                    this.curdForm.tzhskjsxm = this.selectRowData.tzhskjsxm;
                    this.curdForm.tzhcdmc = this.selectRowData.tzhcdmc;

                    this.curdForm.otherExplain = this.selectRowData.otherExplain;

                    this.curdForm.auditAuth = this.selectRowData.auditAuth;
                    this.curdForm.totalAuditLevel = this.selectRowData.totalAuditLevel;
                    this.totalAuditLevel = this.selectRowData.totalAuditLevel;
                    this.curdForm.auditLevel = this.selectRowData.auditLevel;

                    var teaid = "";
                    var teaname = "";
                    var siteid = "";
                    var sitename = "";
                    if(this.selectRowData.applyType=='1'){
                        siteid = this.curdForm.yjhcdbh.split(",");
                        sitename = this.curdForm.yjhcdmc.split(",");
                        for(let i=0;i<siteid.length;i++){
                            this.yjhsiteList.push({'value':siteid[i],'name':sitename[i]});
                        }

                        siteid = this.curdForm.tzhcdbh.split(",");
                        sitename = this.curdForm.tzhcdmc.split(",");
                        for(let i=0;i<siteid.length;i++){
                            this.tzhsiteList.push({'value':siteid[i],'name':sitename[i]});
                        }
                    }else if(this.selectRowData.applyType=='4'){
                        teaid = this.curdForm.yjhskjsbh.split(",");
                        teaname = this.curdForm.yjhskjsxm.split(",");
                        for(let i=0;i<teaid.length;i++){
                            this.yjhteaList.push({'value':teaid[i],'name':teaname[i]});
                        }

                        teaid = this.curdForm.tzhskjsbh.split(",");
                        teaname = this.curdForm.tzhskjsxm.split(",");
                        for(let i=0;i<teaid.length;i++){
                            this.tzhteaList.push({'value':teaid[i],'name':teaname[i]});
                        }


                        siteid = this.curdForm.yjhcdbh.split(",");
                        sitename = this.curdForm.yjhcdmc.split(",");
                        for(let i=0;i<siteid.length;i++){
                            this.yjhsiteList.push({'value':siteid[i],'name':sitename[i]});
                        }

                        siteid = this.curdForm.tzhcdbh.split(",");
                        sitename = this.curdForm.tzhcdmc.split(",");
                        for(let i=0;i<siteid.length;i++){
                            this.tzhsiteList.push({'value':siteid[i],'name':sitename[i]});
                        }
                    }else if(this.selectRowData.applyType=='2'){

                    }else if(this.selectRowData.applyType=='3'){
                        this.curdForm.tzhskjsbh = this.selectRowData.tzhskjsbh.split(",");
                        this.curdForm.tzhcdbh = this.selectRowData.tzhcdbh.split(",");
                    }
                });

                this.queryAttachmentList();
                this.restoreScroll();
            },
            saveInfo(){
                this.curdForm.submitState = '0';
                $('#loadingMask').show();
                this.saveRec();
            },
            saveRec() {
                this.formSubmiting = true;

                this.$refs['curdForm'].validate((valid) => {
                    if (valid) {
                        if(this.curdForm.applyType == ''){
                            this.$message.error('请选择申请类型');
                            $('#loadingMask').hide();
                            return;
                        }
                        if(this.curdForm.applyType!="3"){//不是补课
                            if(this.userAuth == "1"){//admin
                                if(this.editType=="new"){
                                    if(this.curdForm.applyTeacher==""){
                                        this.$message.error("请选择申请教师");
                                        $('#loadingMask').hide();
                                        return;
                                    }
                                }
                            }
                        }
                        if(this.curdForm.majorCode == ''){
                            this.$message.error('请选择专业');
                            $('#loadingMask').hide();
                            return;
                        }
                        if(this.curdForm.classCode == ''){
                            this.$message.error('请选择班级');
                            $('#loadingMask').hide();
                            return;
                        }
                        if(this.curdForm.courseCode == ''){
                            this.$message.error('请选择课程');
                            $('#loadingMask').hide();
                            return;
                        }

                        if(this.curdForm.applyType=="3"){
                            if(this.curdForm.tzhskzc == ''){
                                this.$message.error('请选择周数');
                                $('#loadingMask').hide();
                                return;
                            }
                            if(this.curdForm.tzhxq == ''){
                                this.$message.error('请选择星期');
                                $('#loadingMask').hide();
                                return;
                            }
                            if(this.curdForm.tzhsjxl == ''){
                                this.$message.error('请选择节数');
                                $('#loadingMask').hide();
                                return;
                            }
                        }else{
                            if(this.curdForm.yjhskzc == ''){
                                this.$message.error('请选择周数');
                                $('#loadingMask').hide();
                                return;
                            }
                            if(this.curdForm.yjhxq == ''){
                                this.$message.error('请选择星期');
                                $('#loadingMask').hide();
                                return;
                            }
                            if(this.curdForm.yjhsjxl == ''){
                                this.$message.error('请选择节数');
                                $('#loadingMask').hide();
                                return;
                            }
                        }


                        if(this.curdForm.submitState=="1" && this.fileTableData.length < 1 && this.curdForm.adjustReason=="01"){
                            this.$message.error('请上传调课原因附件');
                            $('#loadingMask').hide();
                            return;
                        }

                        if(this.curdForm.applyType == "1"){//调课
                            this.curdForm.tzhskjsbh = this.curdForm.yjhskjsbh;
                            this.curdForm.tzhskjsxm = this.curdForm.yjhskjsxm;

                            let cdbh = "";
                            let cdmc = "";
                            for(let i=0;i<this.tzhsiteList.length;i++){
                                cdbh += this.tzhsiteList[i].value + ",";
                                cdmc += this.tzhsiteList[i].name + ",";
                            }
                            if(cdbh!=""){
                                this.curdForm.tzhcdbh = cdbh.substring(0,cdbh.length-1);
                                this.curdForm.tzhcdmc = cdmc.substring(0,cdmc.length-1);
                            }
                        }else if(this.curdForm.applyType == "4"){//代课
                            this.curdForm.tzhskzc = this.curdForm.yjhskzc;
                            this.curdForm.tzhxq = this.curdForm.yjhxq;
                            this.curdForm.tzhsjxl = this.curdForm.yjhsjxl;

                            let jsbh = "";
                            let jsmc = "";
                            for(let i=0;i<this.tzhteaList.length;i++){
                                jsbh += this.tzhteaList[i].value + ",";
                                jsmc += this.tzhteaList[i].name + ",";
                            }
                            if(jsbh!=""){
                                jsbh = jsbh.substring(0,jsbh.length-1);
                                jsmc = jsmc.substring(0,jsmc.length-1);
                                this.curdForm.tzhskjsbh = jsbh;
                                this.curdForm.tzhskjsxm = jsmc;
                            }

                            let cdbh = "";
                            let cdmc = "";
                            for(let i=0;i<this.tzhsiteList.length;i++){
                                cdbh += this.tzhsiteList[i].value + ",";
                                cdmc += this.tzhsiteList[i].name + ",";
                            }
                            if(cdbh!=""){
                                this.curdForm.tzhcdbh = cdbh.substring(0,cdbh.length-1);
                                this.curdForm.tzhcdmc = cdmc.substring(0,cdmc.length-1);
                            }

                            if(this.curdForm.yjhskjsbh == jsbh){
                               this.$message.error('代课教师相同，无法保存');
                               $('#loadingMask').hide();
                               return;
                            }
                        }else if(this.curdForm.applyType == "3"){//补课
                            this.curdForm.yjhskzc = '';
                            this.curdForm.yjhxq = '';
                            this.curdForm.yjhsjxl = '';
                            this.curdForm.yjhskjsbh = '';
                            this.curdForm.yjhskjsxm = '';
                            this.curdForm.yjhcdbh = '';
                            this.curdForm.yjhcdmc = '';

                            let jsbh = (this.curdForm.tzhskjsbh+'').split(",");
                            let cdbh = (this.curdForm.tzhcdbh+'').split(",");
                            let jsmc = "";
                            let cdmc = "";

                            for(let i=0;i<jsbh.length;i++){
                                let objtea = {};
                                objtea = this.tzhteacherInfo.find((item)=>{
                                    return item.comboValue === jsbh[i];//筛选出匹配数据
                                });
                                jsmc += objtea.teacherName+",";
                            }
                            if(jsmc!=""){
                                this.curdForm.tzhskjsxm = jsmc.substring(0,jsmc.length-1);
                            }

                            for(let i=0;i<cdbh.length;i++){
                                let objsite = {};
                                objsite = this.tzhsiteInfo.find((item)=>{
                                    return item.comboValue === cdbh[i];//筛选出匹配数据
                                });
                                cdmc += objsite.siteName+",";
                            }
                            if(cdmc!=""){
                                this.curdForm.tzhcdmc = cdmc.substring(0,cdmc.length-1);
                            }
                        }else if(this.curdForm.applyType == "2"){//停课
                            this.curdForm.tzhskzc = '';
                            this.curdForm.tzhxq = '';
                            this.curdForm.tzhsjxl = '';
                            this.curdForm.tzhskjsbh = '';
                            this.curdForm.tzhskjsxm = '';
                            this.curdForm.tzhcdbh = '';
                            this.curdForm.tzhcdmc = '';
                        }

                        if(this.curdForm.applyType=="1"){
                            if(this.curdForm.yjhskzc.length != this.curdForm.tzhskzc.length){
                                this.$message.error('原计划与调整后周次数量不相等，无法保存');
                                $('#loadingMask').hide();
                                return;
                            }

                            if(this.curdForm.yjhsjxl.length != this.curdForm.tzhsjxl.length){
                                this.$message.error('原计划与调整后节数数量不相等，无法保存');
                                $('#loadingMask').hide();
                                return;
                            }

                            if(this.curdForm.yjhskzc == this.curdForm.tzhskzc+'' && this.curdForm.yjhxq == this.curdForm.tzhxq &&
                               this.curdForm.yjhsjxl == this.curdForm.tzhsjxl+'' && this.curdForm.yjhcdbh == this.curdForm.tzhcdbh){
                               this.$message.error('调课时间和场地相同，无法保存');
                               $('#loadingMask').hide();
                               return;
                            }
                        }

                        const paramMap = {
                            'id': this.curdForm.id,
                            'xnxqbm':this.curdForm.xnxqbm,
                            'skjhmxbh':this.curdForm.skjhmxbh,
                            'applyType':this.curdForm.applyType,
                            'applyTeacher':this.curdForm.applyTeacher,
                            'majorCode':this.curdForm.majorCode,
                            'classCode':this.curdForm.classCode,
                            'courseCode':this.curdForm.courseCode,
                            'adjustReason':this.curdForm.adjustReason,
                            'changeReason':this.curdForm.changeReason,
                            'yjhskzc':this.curdForm.yjhskzc+'',
                            'yjhxq':this.curdForm.yjhxq,
                            'yjhsjxl':this.curdForm.yjhsjxl+'',
                            'yjhskjsbh':this.curdForm.yjhskjsbh,
                            'yjhskjsxm':this.curdForm.yjhskjsxm,
                            'yjhcdbh':this.curdForm.yjhcdbh,
                            'yjhcdmc':this.curdForm.yjhcdmc,
                            'tzhskzc':this.curdForm.tzhskzc+'',
                            'tzhxq':this.curdForm.tzhxq,
                            'tzhsjxl':this.curdForm.tzhsjxl+'',
                            'tzhskjsbh':this.curdForm.tzhskjsbh+'',
                            'tzhskjsxm':this.curdForm.tzhskjsxm,
                            'tzhcdbh':this.curdForm.tzhcdbh+'',
                            'tzhcdmc':this.curdForm.tzhcdmc,
                            'otherExplain':this.curdForm.otherExplain,
                            'editType': this.editType,
                            'submitState': this.curdForm.submitState,
                        };

                        this.$api.courseAdjust.courseAdjust.saveAdjust({
                            data: paramMap,
                        }).then((response) => {
                            let state = response.data.data.state;
                            let msg = response.data.data.msg;

                            if (state == 'Success') {
                                this.$notify({
                                    title: "成功",
                                    message: msg ? msg : "保存成功",
                                    type: "success",
                                    duration: 1500,
                                });

                                if(this.editType=="new" && this.curdForm.id==''){
                                    let bh = response.data.data.bh;
                                    this.curdForm.id = bh;
                                }
                                if(this.curdForm.submitState == '1'){
                                    this.dialogVisible = false;
                                }
                                this.requeryList();
                            }else{
                                if(state == 'unaudit'){
                                    this.$message.warning(msg);
                                }else{
                                    this.$notify({
                                        title: "失败",
                                        message: msg ? msg : '保存失败',
                                        type: "error",
                                        duration: 3000,
                                    });
                                }
                                $('#loadingMask').hide();
                            }
                        }).catch((error) => {
                            this.$notify({
                                title: "错误",
                                message: error,
                                type: "error",
                                duration: 3000,
                            });
                            $('#loadingMask').hide();
                        });
                    } else {
                        return false;
                    }
                });

                this.formSubmiting = false;
            },
            submitRec(){
                confirmMsg('提交后将无法再修改调课信息，是否继续？', 'el-message-box-mobile').then(() => {
                    this.curdForm.submitState = '1';
                    $('#loadingMask').show();
                    this.saveRec();
                });
            },
            delRec(rowData){
                confirmMsg('是否确定要删除该申请？', 'el-message-box-mobile').then(() => {
                    this.curdForm.id = rowData.id;

                    this.$api.courseAdjust.courseAdjust.delApply({
                        data: this.curdForm,
                    }).then((response) => {
                        let state = response.data.data.state;

                        if (state == 'Success') {
                            this.$notify({
                                title: "成功",
                                message: "删除成功",
                                type: "success",
                                duration: 1500,
                            });

                            this.requeryList();
                        }else{
                            this.$notify({
                                title: "失败",
                                message: "删除失败",
                                type: "error",
                                duration: 3000,
                            });
                        }
                    }).catch((error) => {
                        this.$notify({
                            title: "错误",
                            message: error,
                            type: "error",
                            duration: 3000,
                        });
                    });
                });
            },
            closeDialog() {
                this.curdForm.id = '';
                this.curdForm.xnxqbm = '';
                this.curdForm.xnxqmc = '';
                this.curdForm.applyType = '';
                this.curdForm.applyTeacher = '';
                this.curdForm.majorCode = '';
                this.curdForm.classCode = '';
                this.curdForm.courseCode = '';
                this.curdForm.applyTypeName = '';
                this.curdForm.applyTeacherName = '';
                this.curdForm.majorName = '';
                this.curdForm.className = '';
                this.curdForm.courseName = '';
                this.curdForm.adjustReason = '';
                this.curdForm.adjustReasonName = '';
                this.curdForm.changeReason = '';

                this.curdForm.yjhskzc = '';
                this.curdForm.yjhxq = '';
                this.curdForm.yjhsjxl = '';
                this.curdForm.yjhskjsbh = '';
                this.curdForm.yjhskjsxm = '';
                this.curdForm.yjhcdbh = '';
                this.curdForm.yjhcdmc = '';

                this.curdForm.tzhskzc = '';
                this.curdForm.tzhxq = '';
                this.curdForm.tzhsjxl = '';
                this.curdForm.tzhskjsbh = '';
                this.curdForm.tzhskjsxm = '';
                this.curdForm.tzhcdbh = '';
                this.curdForm.tzhcdmc = '';

                this.curdForm.otherExplain = '';
                this.curdForm.submitState = '';
                this.curdForm.auditState = '';
                this.curdForm.auditLevel = '';
                this.curdForm.auditAuth = '';
                this.curdForm.totalAuditLevel = '';

                this.disabled = true;
                this.dialogVisible = false;
                this.editType = null;

                this.yjhteaList = [];
                this.yjhsiteList = [];
                this.tzhteaList = [];
                this.tzhsiteList = [];
                this.adjustFlag = "";
            },
            showDetailInfo(rowData){
                this.selectRowData = rowData;
                this.detailDialogTitle = '详情';
                this.detailDialogTop = '250px';
                this.editType = "show";
                this.auditDisabled = true;
                this.operateAreaVisible = false;
                this.modRec(rowData);
            },
            //查询附件信息
            queryAttachmentList(){
                this.fileTableLoading = true;

                let code = "";
                if(this.editType == "new"){
                    code = this.curdForm.id;
                }else{
                    code = this.selectRowData.id;
                }
                this.$api.courseAdjust.courseAdjust.attachmentList({
                    data: { designCode: code },
                }).then((response) => {
                    this.fileTableData = response.data.data.list;
                    this.fileTableLoading = false;
                }).catch((error) => {
                    this.fileTableLoading = false;
                    console.log(error);
                });
            },
            //http-request上传方法（未使用）
            getFile(fileObj) {
                this.file = fileObj.file;
                //this.handleUpload(fileObj);
            },
            //当上传文件有变更时
            onChangeFile(file, fileList) {
                //文件类型限制
                let fileTypeArray = [];
                fileTypeArray.push('txt','doc','docx','xls','xlsx','pdf', 'ppt');//文本文件
                fileTypeArray.push('jpg','jpeg','png','gif');//图片
                fileTypeArray.push('mp3');//音频
                fileTypeArray.push('mp4');//视频
                let suffix = file.name.substring(file.name.lastIndexOf(".") + 1, file.name.length).toLowerCase();
                //文件大小限制
                const sizeLimit = this.fileSizeLimit * 1024 * 1024;

                //判断文件类型及大小是否符合要求
                if (fileTypeArray.indexOf(suffix) < 0 || file.size > sizeLimit) {
                    this.$message({
                        message: '不符合要求的文件已自动过滤',
                        type: 'error'
                    });

                    let index = fileList.findIndex( fileItem => {
                        return fileItem.uid === file.uid
                    });
                    fileList.splice(index, 1); //从上传文件列表删除当前选中文件
                } else {
                    this.fileList = [];
                    this.fileList = fileList;
                }
            },
            //上传文件
            handleUpload() {
                /* let repeatFlag = false;
                for(let i=0; i<this.fileList.length; i++){
                    for(let j=0; j<this.fileTableData.length; j++){
                        if(this.fileList[i].name == this.fileTableData[j].fileName + '.' + this.fileTableData[j].fileType){
                            repeatFlag = true;
                        }
                    }
                }
                if(repeatFlag){
                    confirmMsg('存在相同名称的文件，上传将覆盖原文件，是否确定上传？', 'el-message-box-mobile').then(() => {
                        this.uploadFile();
                    });

                    return;
                } */

                if(this.fileList.length === 0){
                    this.$message({
                        message: '请先选择上传的文件',
                        type: 'warning'
                    });

                    return;
                }

                this.uploadFile();
            },
            uploadFile(){
                const loading = this.$loading({
                    lock: true,
                    text: '文件上传中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                //添加参数
                var formData = new FormData();
                for (let i=0; i<this.fileList.length; i++) {
                    formData.append("files", this.fileList[i].raw);
                }

                let code = "";
                if(this.editType == "new"){
                    code = this.curdForm.id;
                }else{
                    code = this.selectRowData.id;
                }
                formData.append("designCode", code);

                this.$api.courseAdjust.courseAdjust.uploadMultiFile({
                    data: formData,
                }).then(response => {
                    if (response.data.data.state == "Success") {
                        showNotify('成功', '上传成功', 'success', 1500);

                        this.uploadDialogVisible = false;
                        this.fileList = [];
                        this.$refs.uploadFile.clearFiles(); //把之前上传的清空
                        this.queryAttachmentList();
                    } else {
                        showNotify('失败', '上传失败', 'error', 3000);
                    }

                    loading.close();
                }).catch(error => {
                    showNotify('错误', error, 'error', 3000);
                    this.fileList = [];
                    this.$refs.uploadFile.clearFiles(); //把之前上传的清空
                    loading.close();
                });
            },
            handleRemove(file, fileList) {
                //console.log(file,fileList);
                this.fileList = [];
                this.fileList = fileList;
            },
            closeAttachDialog(){
                this.attachmentVisible = false;
            },
            closeUploadDialog() {
                this.uploadDialogVisible = false;
                this.fileList = [];
                this.$refs.uploadFile.clearFiles();
            },
            handleExceed(files, fileList) {
                this.$message.warning(`每次上传限制最多选择10个文件`);
            },
            // 文件上传成功时的函数
            handleFilUploadSuccess(res, file, fileList) {
                // console.log(res, file, fileList)
                this.$message.success("上传成功")
            },
            confirmDelFile() {
                if (this.$refs.multipleTable.selection.length == 0) {
                    this.$message({
                        title: '提示',
                        message: '请选择要删除的附件！',
                        type: 'warning',
                        duration: 2000,
                    });
                    return;
                }

                confirmMsg('此操作将永久删除附件信息, 是否继续?', 'el-message-box-mobile').then(() => {
                    this.delFile();
                });
            },
            delFile(){
                let selectArray = this.$refs.multipleTable.selection;
                let selections = "";
                for (let i=0; i<selectArray.length; i++) {
                    selections += selectArray[i].id + ",";
                }
                if (selections.length > 0) {
                    selections = selections.substring(0, selections.length - 1);
                }

                this.$api.courseAdjust.courseAdjust.delFile({
                    data: { id:selections }
                }).then(response => {
                    let state = response.data.data.state;

                    if (state == 'Success') {
                        showNotify('成功', '删除成功', 'success', 1500);
                        this.queryAttachmentList();
                    }else{
                        showNotify('失败', '删除成功', 'error', 3000);
                    }
                }).catch(error => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            showAttachment(rowData){
                this.fileInfo.name = rowData.fileName;
                this.fileInfo.type = rowData.fileType;
                this.fileInfo.url = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi + rowData.previewPath;
                this.fileName = rowData.fileName + '.' + rowData.fileType;
                this.previewerDialogVisible = true;
            },
            downloadAttachment(rowData){
                const fileUrl = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi + rowData.filePath;
                let exist = this.isExistFile(fileUrl);
                if (exist) {
                    this.downloadFile(fileUrl, rowData.fileName+'.'+rowData.fileType);
                } else {
                    showNotify('错误', '文件不存在，如有疑问请联系管理员！', 'error', 3000);
                }
            },
            downloadFile(url, fileName) {
                let x = new XMLHttpRequest();
                x.open("GET", url, true);
                x.responseType = 'blob';
                x.onload = function(e) {
                    var url = window.URL.createObjectURL(x.response)
                    var a = document.createElement('a');
                    a.href = url
                    a.download = fileName;
                    a.click()
                }
                x.send();
            },
            isExistFile(url) {
                if (url == null || url == undefined || url == "") {
                    return false;
                }
                let xmlhttp;
                if (window.XMLHttpRequest) {
                    xmlhttp = new XMLHttpRequest();
                } else {
                    xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
                }
                xmlhttp.open("GET", url, false);
                xmlhttp.send();
                if (xmlhttp.readyState == 4) {
                    if (xmlhttp.status == 200) return true;
                    //url存在
                    else if (xmlhttp.status == 404) return false;
                    //url不存在
                    else return false; //其他状态
                }
            },
            //查询审核调用参数
            queryAuditParam(){
                this.auditParam = "TKSQ";
                this.queryForm.itemCode = this.auditParam;
                this.queryList();

                // const pageName = this.$route.path.substring(this.$route.path.lastIndexOf("/")+1);
                // this.$api.common.audit.auditParam({
                //     data: { pageName: pageName },
                // }).then((res) => {
                //     this.auditParam = res.data.data.auditParam;
                //     this.queryForm.itemCode = this.auditParam;
                //     this.queryList();
                // }).catch((err) => {
                //     console.log(err);
                // });
            },
            auditRec(rowData){
                this.timer = new Date().getTime();
                this.selectRowData = rowData;
                this.dialogTitle = '审核';
                this.dialogVisible = true;
                this.operateAreaVisible = false;
                this.applyused = true;

                this.xgbh = rowData.id;
                this.auditDisabled = true;
                this.editType = "audit";
                this.modRec(rowData);
                this.$nextTick().then(() => {
                    this.checkApplyUsed();
                });
            },
            //验证教师和场地是否已被使用
            checkApplyUsed(){
                this.showLoadingMask("课程表验证中，请稍候");

                const paramMap = {
                    'id': this.curdForm.id,
                    'xnxqbm':this.curdForm.xnxqbm,
                    'skjhmxbh':this.curdForm.skjhmxbh,
                    'applyType':this.curdForm.applyType,
                    'applyTeacher':this.curdForm.applyTeacher,
                    'majorCode':this.curdForm.majorCode,
                    'classCode':this.curdForm.classCode,
                    'courseCode':this.curdForm.courseCode,
                    'yjhskzc':this.curdForm.yjhskzc+'',
                    'yjhxq':this.curdForm.yjhxq,
                    'yjhsjxl':this.curdForm.yjhsjxl+'',
                    'yjhskjsbh':this.curdForm.yjhskjsbh,
                    'yjhskjsxm':this.curdForm.yjhskjsxm,
                    'yjhcdbh':this.curdForm.yjhcdbh,
                    'yjhcdmc':this.curdForm.yjhcdmc,
                    'tzhskzc':this.curdForm.tzhskzc+'',
                    'tzhxq':this.curdForm.tzhxq,
                    'tzhsjxl':this.curdForm.tzhsjxl+'',
                    'tzhskjsbh':this.curdForm.tzhskjsbh+'',
                    'tzhskjsxm':this.curdForm.tzhskjsxm,
                    'tzhcdbh':this.curdForm.tzhcdbh+'',
                    'tzhcdmc':this.curdForm.tzhcdmc,
                    'editType': this.editType,
                    'submitState': this.curdForm.submitState,
                };
                this.$api.courseAdjust.courseAdjust.checkApplyUsed({
                    data: paramMap,
                }).then((response) => {
                    let state = response.data.data.state;
                    let msg = response.data.data.msg;

                    if (state == 'Success') {
                        this.applyused = false;
                        this.closeLoadingMask();
                    }else{
                        this.$confirm(msg,'提示',{
                            confirmButtonText: '驳回',
                            cancelButtonText: '取消',
                            customClass: 'el-message-box-mobile',
                            type: 'warning'
                        }).then(() => {
                            const paramMap = {
                                'relatedCode': this.curdForm.id,
                                'auditState': "2",//驳回
                                'auditLevel': this.curdForm.auditLevel,
                                'itemCode': this.auditParam,
                                'opinion': msg,
                            }
                            this.$api.courseAdjust.courseAdjust.auditReject({
                                data: paramMap,
                            }).then((response) => {
                                let state = response.data.data.state;
                                if(state == 'Success'){
                                    this.$notify({
                                        title: "成功",
                                        message: "审核成功",
                                        type: "success",
                                        duration: 1500,
                                    });
                                    this.dialogVisible = false;
                                    this.queryList();
                                }else{
                                    this.$notify({
                                        title: "失败",
                                        message: "审核失败",
                                        type: "error",
                                        duration: 1500,
                                    });
                                }
                            }).catch((err) => {
                                console.log(err);
                            });
                        });
                        this.applyused = true;
                        this.closeLoadingMask();
                    }
                }).catch((error) => {
                    this.$notify({
                        title: "错误",
                        message: error,
                        type: "error",
                        duration: 3000,
                    });
                    this.applyused = false;
                    this.closeLoadingMask();
                });
            },
            auditOption(){
                this.detailDialogTitle = this.numarray[parseInt(this.curdForm.auditLevel)-1]+'级审核';
                this.detailDialogTop = '250px';
                this.detailDialogVisible = true;
                this.auditAreaVisible = true;
            },
            //审核后回调函数
            auditCallback(auditInfo){
                this.detailDialogVisible = false;
                this.dialogVisible = false;
                this.auditAreaVisible = false;
                if(auditInfo.auditLevel==this.totalAuditLevel && auditInfo.auditState=="1"){//最后一级审核通过
                    $('#loadingMask').show();
                    this.updateApplyState(auditInfo,"last");
                }else if(auditInfo.auditState=="2"){//审核驳回
                    this.updateApplyState(auditInfo,auditInfo.auditState,auditInfo.auditLevel);
                }else{//非最后一级审核通过
                    this.updateApplyState(auditInfo,auditInfo.auditState,auditInfo.auditLevel);
                    this.requeryList();
                }
            },
            //显示审核详情列表
            showAuditList(row) {
                this.$api.courseAdjust.courseAdjust.queryAuditFlow({
                    data: {
                        itemCode: this.queryForm.itemCode,
                        relatedCode: row.id,
                        auditState: row.auditState,
                        auditLevel: row.auditLevel,
                        courseDept: row.xbdm,
                    },
                }).then((res) => {
                    if (res.data.data.state == 'success') {
                        this.auditFlowInfo = res.data.data.auditFlowInfo;
                    }else{
                        this.auditFlowInfo = null;
                    }
            
                    this.selectRowData = row;
                    this.auditListDialogVisible = true;
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            updateApplyState(auditInfo,level,auditLevel){
                const paramMap = {
                    'id': auditInfo.relatedCode,
                    'auditState': auditInfo.auditState,
                    'auditLevel': auditLevel,
                    'level': level,
                    'classCode': this.curdForm.classCode,
                }
                this.$api.courseAdjust.courseAdjust.updateAuditState({
                    data: paramMap,
                }).then((response) => {
                    let state = response.data.data.state;
                    if(state == 'fail'){
                        this.$notify({
                            title: "失败",
                            message: "审核状态更新失败",
                            type: "error",
                            duration: 3000,
                        });
                    }
                    this.requeryList();
                }).catch((error) => {
                    this.$notify({
                        title: "错误",
                        message: error,
                        type: "error",
                        duration: 3000,
                    });
                });
            },
            getCurrentFormatDate(){
                var date = new Date();
                var seperator1 = "-";
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                var currentdate = year + seperator1 + month + seperator1 + strDate;
                return currentdate;
            },
            formatJS(str){
                let result = "";
                let js = str.split(",");
                for(let i=0;i<js.length;i++){
                    result += parseInt(js[i],10)+",";
                }
                if(result!=''){
                    result = result.substring(0,result.length-1);
                }
                return result;
            },
            //显示loading
            showLoadingMask(str) {
                this.loadingMask = this.$loading({
                    lock: true,
                    text: str,
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.8)",
                });
            },
            //关闭loading
            closeLoadingMask() {
                if (this.loadingMask) this.loadingMask.close();
            },
        },
    };
</script>
<style src="styles/mobile.css"></style>
<style scoped>
    #mobileMode #queryArea {
        height: 90px;
        margin: 10px 0 10px 0;
    }

    #mobileMode #queryDialog {
        top: 150px;
    }

    #mobileMode #mainDialogScroll {
        height: 65vh;
        padding: 10px 20px;
    }

    #mobileMode #loadingTips {
        height: 30px;
        line-height: 30px;
        color: #9d9d9d;
        position: relative;
        bottom: 0;
        text-align: center;
    }

    .el-dialog-div{
        height: 60vh;
        overflow: auto;
    }
    .attachmentUpload /deep/ .el-upload-dragger {
        width: 320px;
        height: 240px;
    }
    .maskStyle{
        width:960px;
        overflow:hidden;
        background-color:#ffffff;
        filter:alpha(opacity=60);
        -moz-opacity:0.6;
        opacity: 0.3;
        position:absolute;
        top:0px;
        left:0px;
        z-index:100;
    }
    .xsyjDialog {
        top: 20vh;
    }
    .maskStyle{
        width:100%;
        height:100%;
        overflow:hidden;
        display:none;
        background-color:#000000;
        filter:alpha(opacity=60);
        -moz-opacity:0.6;
        opacity: 0.6;
        position:absolute;
        top:0px;
        left:0px;
        z-index:100;
    }

    .maskFont{
         font-size:16px;
         font-weight:bold;
         color:#ffffff;
         width:230px;
         height:100%;
         position:absolute;
         top:50%;
         left:50%;
         margin-top:-10px;
         margin-left:-90px;
    }
</style>



// WEBPACK FOOTER //
// adjustClasses.vue?117fa3ef